import StepNotice from "./StepNotice";
import type { BulkImportReview } from "./types";

interface ImportReviewNoticesProps {
  review: Pick<BulkImportReview, "skipped" | "errors">;
}

/**
 * What the importer left for the bulk wizard to say: the skipped line as an info notice, and the
 * rows to fix as a blocking one, a line each (scrolling once the list runs long). StepNotice wraps
 * its children in a `<p>`, so the lines are block-level spans. Nothing to say renders nothing.
 */
export default function ImportReviewNotices({ review }: ImportReviewNoticesProps) {
  const { skipped, errors } = review;
  if (skipped === null && errors.length === 0) return null;
  return (
    <>
      {skipped !== null && <StepNotice tone="neutral">{skipped}</StepNotice>}
      {errors.length > 0 && (
        <StepNotice blocking>
          <span className="block max-h-[40vh] overflow-y-auto">
            {errors.map((line) => (
              <span key={line} className="block">
                {line}
              </span>
            ))}
          </span>
        </StepNotice>
      )}
    </>
  );
}
